<div class="tz-root">
  <!-- Trigger button — styled to match hf-form-select -->
  <button
    #triggerBtn
    type="button"
    class="tz-trigger"
    [class.tz-has-value]="!!selectedLabel"
    [class.tz-error]="hasError"
    [class.tz-open]="isOpen"
    (click)="toggle(triggerBtn)"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox">
    <span class="tz-label" [class.tz-placeholder]="!selectedLabel">
      {{ selectedLabel || placeholder }}
    </span>
    <img src="assets/images/chevron-down.svg" class="tz-chevron" [class.tz-chevron-open]="isOpen" alt="" />
  </button>

  <!-- Dropdown panel via CDK overlay -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerBtn"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOffsetY]="4"
    [cdkConnectedOverlayWidth]="triggerWidth"
    (backdropClick)="close()"
    (detach)="close()">

    <div class="tz-panel">

      <!-- Search input -->
      <div class="tz-search-wrapper">
        <svg class="tz-search-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="6.5" cy="6.5" r="5" stroke="#9ca3af" stroke-width="1.5"/>
          <path d="M10.5 10.5L14 14" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <input
          #searchInput
          type="text"
          class="tz-search-input"
          [(ngModel)]="searchText"
          placeholder="Search time zones..."
          autocomplete="off"
          (click)="$event.stopPropagation()"
        />
        @if (searchText) {
          <button type="button" class="tz-search-clear" (click)="searchText = ''; $event.stopPropagation();" aria-label="Clear search">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4L12 12M12 4L4 12" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        }
      </div>

      <!-- Options list -->
      <div class="tz-list" role="listbox">
        @if (!hasResults) {
          <div class="tz-no-results">No time zones found</div>
        }
        @for (group of groupedFilteredZones; track group.region) {
          @if (group.zones.length > 0) {
            <div class="tz-group-header" role="presentation">{{ group.region }}</div>
            @for (zone of group.zones; track zone.id) {
              <div
                class="tz-option"
                [class.tz-option-selected]="zone.id === selectedValue"
                role="option"
                [attr.aria-selected]="zone.id === selectedValue"
                (click)="select(zone)">
                {{ getCityLabel(zone.description) }}
              </div>
            }
          }
        }
      </div>

    </div>
  </ng-template>
</div>
